import React from "react";
import PageHeader from "../components/PageHeader";
import "../css/commontemplate.css";
import { goshalaImg } from '../assets/assets.js'; //asset.js file for images

export const WhyGoseva = () => {
  return (
    <>
      <PageHeader
        title="गोशाळेचे महत्व "
        path="/about-goshala"
        name=" goshala"
      />
      {/* <Initiatives /> */}
      {/* <DynamicContentComponent content={dajimah} heading={" गोशाळेचे महत्व"} /> */}
      <div className="comman-template-section">
        {/* <h1 className="comman-template-section-title">गोसेवेचे महत्त्व</h1> */}

        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              {/* imgcon */}
              <img
                className="comman-template-image"
                src={goshalaImg.g_img_2}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              {/* info container */}
              {/* <h3>गोसेवेचे महत्त्व</h3> */}
              <div className="comman-template-info-container-shlok">
                मातरःसर्वभूताना गाव : सर्वसुखप्रदाः
              </div>
              <p>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; गाय ही सकल
                प्राणिमात्रांची माता असून तिच्याठिकाणी सर्व सुख प्रदान करण्याचे
                सामर्थ्य आहे. प्रतिष्ठान द्वारा संचलित संतवर्य योगिराज
                गंगाजीबापूमहाराज गोसेवा प्रकल्पामध्ये सध्या 50 हून अधिक देशी
                गायींचा समावेश आहे.
              </p>
            </div>
          </div>

          <div className="comman-template-sub-section"></div>
        </div>
      </div>

    </>
  );
};
